/**
 * @class
 * @memberOf P3.audio
 */
export default class Audio {
    /**
     * @param {number} id
     * @param {Howl} howl
     */
    constructor(id, howl) {
        /**
         * @member {number}
         */
        this._id = id;

        /**
         * @member {Howl}
         */
        this._howl = howl;
    }

    destroy() {
        this._onend && this.howl.off("end", this._onend);
        this.stop();
    }

    play() {
        this.howl.play(this.id);
    }

    stop() {
        this.howl.stop(this.id);
    }

    pause() {
        this.howl.pause(this.id);
    }

    /**
     * @returns {number}
     */
    get id() {
        return this._id;
    }

    /**
     * @returns {Howl}
     */
    get howl() {
        return this._howl;
    }
}